import { HttpClient} from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { IImage, Image } from '../../models/media';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService extends ResourceService<Image> {

   /**
   * @constructor 
   * Creates an instance of the ImageService 
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'images');
  }

  
  public setParent(propertyId: string, roomId?: string) {
    let endpoint = `properties/${propertyId}`;
    if (roomId !== undefined) {
      endpoint += `/rooms/${roomId}`;
    }
    this.endpoint = `${endpoint}/images`;
    return this;
  }

}
